var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { class: _vm.$style.heading }, [
      _vm._v("\n    Set Up Verification Code (TOTP) MFA\n  "),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.body }, [
      _c(
        "div",
        { class: _vm.$style.mainContent },
        [
          _c(
            "AdminTotpSetupStep",
            { attrs: { number: 2, title: "Add Your Account" } },
            [
              _c("template", { slot: "adminTotpSetupStepMessage" }, [
                _c("p", [
                  _vm._v(
                    "\n            Scan the QR code to retrieve the validation codes you will need to complete\n            your configuration and verify your future logins to JumpCloud resources.\n          "
                  ),
                ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "AdminTotpSetupStep",
            { attrs: { number: 3, title: "Verify Your Account" } },
            [
              _c("template", { slot: "adminTotpSetupStepMessage" }, [
                _c("p", [
                  _vm._v(
                    '\n            Enter the 6 digit verification code provided for "JumpCloud Admin"\n            from your authenticator application.\n          '
                  ),
                ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "form",
            { class: _vm.$style.totpCodeForm },
            [
              _c("LoginAlert", {
                model: {
                  value: _vm.error,
                  callback: function ($$v) {
                    _vm.error = $$v
                  },
                  expression: "error",
                },
              }),
              _vm._v(" "),
              _c("LoginTextField", {
                class: _vm.$style.totpCode,
                attrs: {
                  autocomplete: false,
                  maxlength: 6,
                  placeholder: "Enter Code",
                  submitOnEnter: _vm.handleSubmit,
                  value: _vm.totpCode,
                  vvName: "verification code",
                },
                on: { input: _vm.handleInput },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("aside", { class: _vm.$style.qrCodeCardContainer }, [
        _c(
          "div",
          { class: _vm.$style.qrCodeCard },
          [
            _c("div", { class: _vm.$style.qrCodeInstruction }, [
              _vm._v("\n          Scan to add account\n        "),
            ]),
            _vm._v(" "),
            _c("QrCode", {
              attrs: { clientType: "admin", isAdmin: true, totp: _vm.totp },
            }),
            _vm._v(" "),
            _c("div", { class: _vm.$style.totpKey }, [
              _vm._v("\n          " + _vm._s(_vm.totp) + "\n        "),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$style.footer },
      [
        _c(
          "button",
          {
            class: _vm.$style.backButton,
            attrs: { type: "button" },
            on: { click: _vm.goBack },
          },
          [_vm._v("\n      Back\n    ")]
        ),
        _vm._v(" "),
        _c(
          "LoginActionButton",
          {
            class: _vm.$style.actionButton,
            attrs: {
              action: _vm.handleSubmit,
              disabled: _vm.isDisabled,
              isLoading: _vm.isLoading,
            },
          },
          [_vm._v("\n      Submit\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }